import * as React from 'react';
import PropTypes from 'prop-types';

import Waypoint from '../classes/Waypoint';

/**
 * A React component for displaying a overlay for providing routing options
 * 
 * @param {any} props 
 * @returns {React.Component}
 */
function RoutingPopup(props) {
    const { 
        setOrigin,
        setDestination,
        top,
        nearestWaypoint,
        clear,
    } = props;

    return (
        <div className="modal is-active routing-popup">
            <div className="modal-card" style={{top: top}}>
                <header className="modal-card-head">
                    <p className="modal-card-title">Custom Routing - {nearestWaypoint.location}</p>
                    <button className="delete" aria-label="close" onClick={clear}></button>
                </header>
                <section className="modal-card-body">
                    <div className="content">
                        Congratulations!  You have successfully double-tapped a location on the map.  Now you have the option to change your current location <b>or</b> set your routing destination.  Way to go!
                    </div>
                </section>
                <footer className="modal-card-foot">
                    <button className="button"
                        onClick={() => {
                            setOrigin(nearestWaypoint);
                            clear();
                        }}
                    >
                        Set Current Location
                    </button>
                    <button className="button"
                        onClick={() => {
                            setDestination(nearestWaypoint);
                            clear();
                        }}
                    >
                        Set Destination
                    </button>
                </footer>
            </div>
        </div>
    );
}

RoutingPopup.propTypes = {
    setOrigin: PropTypes.func.isRequired,
    setDestination: PropTypes.func.isRequired,
    top: PropTypes.number,
    nearestWaypoint: PropTypes.instanceOf(Waypoint),
    clear: PropTypes.func,
}

export default RoutingPopup;



// WEBPACK FOOTER //
// ./src/components/RoutingPopup.js